<template>
 <div class="review-card-small">
   <div class="review-card-small__name-rating">
     <div class="--name">{{ item.name }}</div>
     <div class="--rating">
       <template v-for="(r) in [1,2,3,4,5]">
         <img v-if="item.rating >= r" src="~/assets/img/svg/common/star.svg" alt="rating"/>
         <img v-else src="~/assets/img/svg/common/star-empty.svg" alt="rating"/>
       </template>
     </div>
   </div>
   <div
     ref="refMessage"
     class="review-card-small__message h5"
     :class="{
       '--small': isSmallText,
       '--full': isFullMessage
     }"
   >
     <div v-html="item.text"/>
   </div>
   <div
     v-if="isSmallText"
     class="review-card-small__button-more h6"
     @click="changeFullMessage"
   >
     {{isFullMessage ? 'Свернуть отзыв' : 'Отзыв целиком'}}
     <img src="~/assets/img/svg/common/arrow.svg" alt="arrow">
   </div>

   <template v-if="mediaItems.length > 0">
     <ReviewCardSwiperMedia
       :media="mediaItems"
     />
   </template>
   <div
     v-if="answer"
     class="review-card-small__answer"
   >
     <div class="review-card-small__answer-head">
       <div
         v-if="managerName"
         class="review-card-small__answer-head-title"
       >
         {{ managerName }}
       </div>
       <span
         v-if="publishedDate"
         class="review-card-small__answer-head-date"
       >
          {{publishedDate}}
        </span>
     </div>
     <div
       v-html="answer.text"
       class="review-card-small__answer-text"
     />
   </div>
 </div>
</template>

<script lang="ts" setup>
import type { ComputedRef } from 'vue';

const props = defineProps({
  item: {
    type: Object as any,
    default: () => {}
  }
});
const ReviewCardSwiperMedia = defineAsyncComponent(() => import('./ReviewCardSwiperMedia.vue'));

const dateString = computed(() => {
  const timestamp = props.item?.created_at;
  if (timestamp == null || Number.isNaN(Number(timestamp))) return '';
  try {
    return new Date(Number(timestamp) * 1000).toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'Europe/Moscow'
    });
  } catch {
    return '';
  }
});

const mediaItems: ComputedRef<any[]> = computed(() => {
  const _files = props?.item?.files || [];
  const _images = props?.item?.images_ids || [];

  let _items: any[] = [];
  if (_images.length > 0) {
    _images.map((t: any) => {
      _items.push({
        type: 'image',
        value: t
      })
    })
  }
  if (_files.length > 0) {
    _files.map((t: any) => {
      _items.push({
        type: 'video',
        value: t?.url
      })
    })
  }

  return _items
});

const refMessage: any = ref(null);
const isSmallText = ref(false);
const isFullMessage = ref(false);
const checkFullMessage = () => {
  const fullHeight = refMessage.value?.clientHeight;
  if (fullHeight <= (8 * 22)) {
    return
  }

  isSmallText.value = true;
};
const changeFullMessage = () => {
  isFullMessage.value = !isFullMessage.value;
}
const answer: any = computed(() => {
  return props.item?.children?.[0] || ''
})
const managerName: any = computed(() => {
  // if (!answer.value || !answer.value?.name_value) {
  //   return
  // }
  // return `${answer.value?.name_value || ''} ${answer.value?.name || ''}`
  return 'Менеджер MiaSofia'
})
const publishedDate: any = computed(() => {
  if (!answer.value.created_at) {
    return
  }
  const _date = new Date(answer.value.created_at * 1000)
  const _day = _date.getDate()
  const _month = _date.getMonth()
  const _year = _date.getFullYear()
  const _arrMonths = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря']
  return `${_day} ${_arrMonths[_month]} ${_year}`
})
onMounted(() => {
  checkFullMessage();
});
</script>

<style lang="scss">
.review-card-small {

}

.review-card-small__name-rating {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 16px;

  .--name {
    color: #000;
    font-variant-numeric: lining-nums proportional-nums;
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
  }

  .--rating {
    display: flex;
    align-items: center;

    & > * {
      width: 20px;
      height: 20px;
    }
  }
}

.review-card-small__images {
  display: flex;
  flex-wrap: wrap;
  margin-top: -6px;
  margin-left: -6px;
  margin-bottom: 16px;

  & > * {
    width: calc(100% / 4 - 6px);
    margin-top: 6px;
    margin-left: 6px;
    position: relative;
    overflow: hidden;
    border-radius: 6px;

    img {
      position: absolute;
      top: 0; left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    &:after {
      content: "";
      float: left;
      padding-top: 66.11%;
    }
  }
}

.review-card-small__message {
  margin-bottom: 12px;
  color: #989898;
  line-height: 160%;
  font-weight: 500;

  &.--small {
    -webkit-line-clamp: 8;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-variant-numeric: lining-nums proportional-nums;
    text-overflow: ellipsis;
  }
  &.--full {
    -webkit-line-clamp: 99999;
  }
  &.--full + .review-card-small__button-more img {
    transform: rotate(90deg);
  }
}

.review-card-small__button-more {
  margin-top: auto;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #000;
  opacity: 0.5;
  transition: all 0.2s;

  img {
    width: 16px;
    height: 16px;
    object-fit: contain;
    transform: rotate(270deg);
  }
  &:hover {
    opacity: 1;
  }
}

.review-card-small__answer {
  display: flex;
  flex-direction: column;
  padding: 16px 0 0 60px;
}
.review-card-small__answer-head {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.review-card-small__answer-head-title {
  color: #000;
  font-variant-numeric: lining-nums proportional-nums;
  font-size: 16px;
  font-weight: 500;
  line-height: 160%;
}
.review-card-small__answer-head-date {
  font-size: 14px;
}
.review-card-small__answer-text {
  font-size: 14px;
}

@media (max-width: 1023px) {
  .review-card-small__images {
    & > * {
      width: calc(100% / 3 - 6px);
    }
  }
  .review-card-small__message {
    font-size: 14px!important;
    line-height: 150% !important;
    font-weight: 400;
  }
  .review-card-small__answer {
    padding: 30px 0 0 30px;
  }
  .review-card-small__answer-head-date {
    font-size: 13px;
  }
  .review-card-small__answer-text {
    font-size: 13px;
    line-height: 150%;
  }
}
</style>
